import React from 'react';
import { Button } from '@crisellevaldez/speculo-ui';
import { Tooltip } from '../../common/Tooltip';
import { formatNumber } from '../../../utils/format';
import { useFlywheelEnabled } from '../../../stores/useOrganizationStore';
import { flowActivityBreakdown, flowActivityTotal } from './flowActivity';

/**
 * The flows table Activity cell: everything the flow sent (calls, SMS and
 * email) as one total, with the per-channel split on hover. Clicking opens the
 * flow's Activity feed. A flow that sent nothing shows a dash, not a 0 button.
 */
export const FlowActivityButton: React.FC<{
  calls?: number;
  sms?: number;
  email?: number;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}> = ({ calls, sms, email, onClick, disabled, className }) => {
  // SMS is a Flywheel-only channel: an org without it never sees SMS counted.
  const flywheelEnabled = useFlywheelEnabled();
  const counts = { calls, sms: flywheelEnabled ? sms : 0, email };
  const total = flowActivityTotal(counts);
  if (total === 0) return <span className="text-muted-foreground">-</span>;
  return (
    <Tooltip content={flowActivityBreakdown(counts)} position="top">
      <Button
        variant="outline"
        size="sm"
        onClick={onClick}
        className={`px-3 py-1 text-xs ${className ?? ''}`}
        disabled={disabled}
      >
        {formatNumber(total)}
      </Button>
    </Tooltip>
  );
};
